// ============================================================================
// LES CATÉGORIES DE FRAIS — la liste qui classe un frais réglé en espèces au tiroir.
//
// UTILITÉ : la Console la sème selon le corps de métier, le back-office la tient (Référentiels › Catégories de frais), et
// la caisse la proposera au geste « Frais magasin » : `cash_movement.expense_category` porte alors le CODE d'une ligne.
// D'où ce module au contrat — trois côtés lisent la même sorte de liste.
// ============================================================================

/** La sorte de la liste générique (`reference_list.kind`) qui porte les catégories de frais. */
export const EXPENSE_CATEGORY_KIND = 'expense_category';
